import Column from '@/classes/pages/Column'

export default class Columns extends Array {
  constructor (columns, ...rest) {
    Array.isArray(columns) ? super(...columns.map(column => new Column(column))) : super(...rest)
  }
}
